import { useAppSelector } from "store";
import { CreateSandboxActionHandler } from "./action-handlers/create-sandbox-action-handler/CreateSandboxActionHandler";
import { DeleteSandboxActionHandler } from "./action-handlers/delete-sandbox-action-handler/DeleteSandboxActionHandler";
import { ForkSandboxActionHandler } from "./action-handlers/fork-sandbox-action-handler/ForkSandboxActionHandler";
import { RequireSigninActionHandler } from "./action-handlers/require-signin-action-handler/RequireSigninActionHandler";
import { SandboxSettingsActionHandler } from "./action-handlers/sandbox-settings-action-handler/SandboxSettingsActionHandler";
import { UserNameActionHandler } from "./action-handlers/user-name-action-handler/UserNameActionHandler";
import { LikeSandboxActionHandler } from "./action-handlers/LikeSandboxActionHandler";
import { EmbedSandboxActionHandler } from "./action-handlers/embed-action-handler/EmbedActionHandler";
import { ExportSandboxActionHandler } from "./action-handlers/export-sandbox-action-handler/ExportSandboxActionHandler";
import { MigrationActionHandler } from "./action-handlers/migration-action-handler/MigrationActionHandler";

interface SandboxActionsProps {
  children: React.ReactNode;
}

export const SandboxActions = ({ children }: SandboxActionsProps) => {

  const action = useAppSelector((state) => state.actions.action);

  return (
    <>
      {action?.type === "create" && <CreateSandboxActionHandler  {...action?.args} />}
      {action?.type === "delete" && <DeleteSandboxActionHandler  {...action?.args} />}
      {action?.type === "fork" && <ForkSandboxActionHandler  {...action?.args} />}
      {action?.type === "like" && <LikeSandboxActionHandler  {...action?.args} />}
      {action?.type === "embed" && <EmbedSandboxActionHandler  {...action?.args} />}
      {action?.type === "export" && <ExportSandboxActionHandler  {...action?.args} />}
      {action?.type === "sandbox-settings" && <SandboxSettingsActionHandler  {...action?.args} />}
      {action?.type === "set-username" && <UserNameActionHandler {...action?.args} />}
      {action?.type === "signin-prompt" && <RequireSigninActionHandler {...action?.args} />}
      {action?.type === "update" && <MigrationActionHandler {...action?.args} />}
      {children}
    </>
  )
}